import { useState } from "react";
import { IoLocation } from "react-icons/io5";
import { GENERAL, CENTROS_MAPA_POR_PAIS, CENTRO_MAPA_DEFAULT, ZOOM_MAPA_DEFAULT } from "../../constants";
import { APIProvider, Map, AdvancedMarker } from "@vis.gl/react-google-maps";

// Selector de ubicación reusable y autocontenido (Bloque C Fase 2).
// Coloca el pin de un edificio NUEVO (sin id, sin fila en DB) escribiendo lat/lng
// en estado local del padre vía onChange. Reusa los mismos primitivos y config que
// /mapa (@vis.gl/react-google-maps + GENERAL) pero NO comparte código con él.
//
// Props:
//   initialLat / initialLng : number|null — coord inicial (modo edición); null = nuevo
//   pais                     : "Chile"|"Perú" — centro por defecto si no hay coord inicial
//   onChange(lat, lng)       : se llama en cada drag con la nueva coordenada
export const PinPicker = ({ initialLat = null, initialLng = null, pais, onChange }) => {
  // Coord inicial solo si ambas vienen con valor (un edificio nuevo arranca sin ubicación).
  const tieneInicial = initialLat !== null && initialLat !== "" && initialLng !== null && initialLng !== "";
  const coordInicial = tieneInicial ? { lat: Number(initialLat), lng: Number(initialLng) } : null;

  const [coord, setCoord] = useState(coordInicial);

  // Centro del mapa: la coord inicial si existe, si no el centro del país (fallback Perú).
  // useState con initializer → estable, no recentra en cada render (defaultCenter no-controlado).
  const [centro] = useState(coordInicial || CENTROS_MAPA_POR_PAIS[pais] || CENTRO_MAPA_DEFAULT);

  // El marker necesita una posición siempre: si aún no hay coord, se ancla al centro
  // (visible y arrastrable); coord queda null hasta el primer drag para forzar colocación.
  const markerPosition = coord || centro;

  const handleDragEnd = (e) => {
    const newLat = e.latLng?.lat();
    const newLng = e.latLng?.lng();
    if (newLat != null && newLng != null) {
      setCoord({ lat: newLat, lng: newLng });
      if (onChange) onChange(newLat, newLng);
    }
  };

  return (
    <div>
      <div
        style={{
          height: "320px",
          width: "100%",
          borderRadius: "8px",
          overflow: "hidden",
          border: "1px solid #ced4da",
          position: "relative",
        }}
      >
        <APIProvider apiKey={GENERAL.GMAP_API_KEY}>
          <Map defaultCenter={centro} defaultZoom={ZOOM_MAPA_DEFAULT} mapId={GENERAL.GMAP_MAP_ID}>
            <AdvancedMarker position={markerPosition} draggable onDragEnd={handleDragEnd}>
              <IoLocation style={{ color: "#4A148C", fontSize: "42px" }} />
            </AdvancedMarker>
          </Map>
        </APIProvider>
      </div>
      <p style={{ margin: "8px 0 0", fontWeight: "bold", fontSize: "14px" }}>
        Ubicación:{" "}
        {coord ? (
          <span>
            {coord.lat.toFixed(5)} / {coord.lng.toFixed(5)}
          </span>
        ) : (
          <span style={{ color: "#888", fontWeight: "normal" }}>Sin ubicación — arrastrá el pin</span>
        )}
      </p>
    </div>
  );
};
